import React, { useContext, useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import {  Box,  Button,  Header,  Keyboard,  ResponsiveContext,  Text,  TextInput,} from 'grommet';
import {  Chat,  Hpe,  Notification,  Search as SearchIcon,  User,} from 'grommet-icons';


const StyledTextInput = styled(TextInput).attrs(() => ({
  'aria-labelledby': 'search-complex-example',
}))``;


const HeaderExample = (props) => (
  <div className={'hpehf-header'}>
  <Header fill="horizontal">
    <Button>
      <Box
        direction="row"
        align="start"
        gap="medium"
        // pad maintains accessible hit target
        // non-responsive maintains same dimensions for mobile
        pad={{ vertical: 'small' }}
        responsive={false}
      >
        <Hpe color="brand" />
        <Box direction="row" gap="small" wrap>
          <Text color="text-strong" weight="bold">
            HPE
          </Text>
          <Text color="text-strong">{props.name}</Text>
        </Box>
      </Box>
    </Button>
    
  </Header>
  </div>
);

export default HeaderExample